import { useMemo } from 'react';

interface HookReturnType {
  marca: string;
  numero: string;
  containerIsValid: boolean;
}
const useContainerExtractedValidations = (
  containerString: string,
  isBooking: boolean = false
): HookReturnType => {
  const { marca, numero, containerIsValid } = useMemo(() => {
    const regexValidate = isBooking ? /^[A-Za-z0-9]*$/ : /^[A-Za-z]{4}\d{7}$/;
    const isValid = regexValidate.test(containerString);

    if (isValid) {
      return {
        marca: containerString.slice(0, 4),
        numero: containerString.slice(4),
        containerIsValid: isValid,
      };
    }

    return { marca: '', numero: '', containerIsValid: isValid };
  }, [containerString, isBooking]);

  return { marca, numero, containerIsValid };
};

export default useContainerExtractedValidations;
